import { useConfigStore as t } from "@phx-husky/auth-context";
import r from "@phx-husky/auth-service";
import { useRef as e } from "react";
var o = function o() {
  var _t = t(),
    o = _t.services,
    c = _t.config,
    _e = e(r.getInstance(o, c)),
    n = _e.current;
  return n;
};
export { o as useAuth };